import { css } from '@emotion/react';
import { semantic_colors, shapes, text_styles } from '../../foundation';
import { getAutoColorCode } from '../../styles';

export const tree_button_css = css`
  display: flex;
  width: 100%;
  margin: 0;
  padding: 6px 8px 6px 4px;
  border-radius: 8px;
  gap: 4px;
  align-items: center;
  box-sizing: border-box;
  border: none;
  background: ${semantic_colors.background.surface};
  text-align: left;
  font: inherit;
  ${text_styles.Body_14_Regular};
  color: ${semantic_colors.content.primary};
  transition: 0.1s background-color linear;
  cursor: pointer;

  &:hover {
    background-color: ${getAutoColorCode(semantic_colors.background.surface).hover};
  }
  &:active {
    background-color: ${getAutoColorCode(semantic_colors.background.surface).pressed};
  }
`;

export const tree_checkable_button_css = css`
  padding: 5px 8px 5px 4px;
`;

export const tree_button_selected_css = css`
  ${text_styles.Body_14_SemiBold};
  color: ${semantic_colors.accent.primary};
  background-color: ${semantic_colors.accent.light};
  &:hover {
    background-color: ${getAutoColorCode(semantic_colors.accent.light).hover};
  }
  &:active {
    background-color: ${getAutoColorCode(semantic_colors.accent.light).pressed};
  }
`;

export const divider_css = css`
  width: 1px;
  margin: -4px 8px;
  align-self: stretch;
  background-color: ${semantic_colors.border.primary};
`;

export const icon_slot_css = css`
  display: block;
  width: 16px;
  line-height: 0;
`;

export const icon_slot_toggle_css = css`
  cursor: pointer;
  ${shapes.border_radius.xsmall};
  &:hover {
    background-color: ${getAutoColorCode(semantic_colors.background.surface).hover};
  }
`;

export const icon_css = css`
  transition: 0.1s transform linear;
`;

export const icon_open_css = css`
  transform: rotate(90deg);
`;

export const tree_text_css = css`
  flex: 1 0 0px;
  min-width: 0;
  overflow-wrap: break-word;
  > b {
    font-weight: inherit;
    color: ${semantic_colors.state.negative};
  }
`;

export const tree_action_css = css`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 0 6px;
  ${text_styles.Body_12_Regular};
  color: ${semantic_colors.content.primary};
  opacity: 0;
  transition: 0.1s opacity;
  button:hover > &,
  button:active > &,
  button:focus-visible > & {
    opacity: 1;
  }
`;

export const tree_list_css = css`
  list-style: none;
  margin: 0;
  padding: 0;
`;
